import React from 'react';
import { ValidationError } from '@nextinq.public/usable-form/lib/types';
import styled from 'styled-components';
import { colors } from '../themes';
import { ErrorItem } from './error-item';

const Container = styled.div`
  border: 1px solid ${colors.status.error};
  background-color: ${colors.statusBg.error};
`;

interface ErrorSummaryProps {
  errors: Array<ValidationError>;
}

export function ErrorSummary(props: ErrorSummaryProps) {
  const { errors } = props;
  if (errors.length === 0) {
    return null;
  }
  return (
    <Container>
      {errors.map((err) => (
        <ErrorItem error={err} key={err.code} />
      ))}
    </Container>
  );
}
